<ul class="dropdown-menu canvas-context-menu">
  <p *ngIf="hideWidgetName" class="menu-heading">{{locale.LABEL_WIDGET}}</p>

    <li data-id="open-partial">
        <a><i class="wms wms-edit"></i> {{locale.LABEL_EDIT}}</a>
    </li>
    <li data-id="cut">
        <a><i class="wms wms-content-cut"></i> {{locale.LABEL_CUT}}</a>
    </li>
    <li data-id="copy">
        <a><i class="wms wms-content-copy"></i> {{locale.LABEL_COPY}}</a>
    </li>
    <li data-id="paste">
        <a><i class="wms wms-content-paste"></i> {{locale.LABEL_PASTE}}</a>
    </li>
    <li data-id="delete">
        <a><i class="wms wms-delete"></i> {{locale.LABEL_DELETE}}</a>
    </li>
    <li data-id="duplicate">
        <a><i class="wms wms-clone"></i> {{locale.LABEL_DUPLICATE}}</a>
    </li>
  <li data-id="autolayout">
    <a><i class="wms wms-layout"></i> {{locale.LABEL_ADD_AUTOLAYOUT || 'Add Auto Layout'}}</a>
  </li>
  <li *ngIf="hideWidgetName" class="divider dropdown-divider"></li>
  <p class="menu-heading">{{locale.LABEL_CANVAS}}</p>
  <li data-id="showHide">
    <a><i class=" fa" [ngClass]="{'fa-eye': pageWsService.showHiddenElements, 'fa-eye-slash' : !pageWsService.showHiddenElements}"></i> {{locale.LABEL_SHOWHIDE}}</a>
  </li>
  <li data-id="undo">
    <a ><i class="wms wms-undo"></i> {{locale.LABEL_UNDO}}</a>
  </li>
  <li data-id="redo">
    <a><i class="wms wms-redo"></i> {{locale.LABEL_REDO}}</a>
  </li>
  <li data-id="save">
    <a><i class="wms wms-save"></i> {{locale.LABEL_SAVE}}</a>
  </li>
  <li data-id="collapse">
    <a><i class="wms wms-layout"></i> {{(pageWsService.hideResources && pageWsService.hideEditorProperties) ? locale.LABEL_COLLAPSE : locale.LABEL_EXPAND}}</a>
  </li>
</ul>
